import { useMemo } from 'react';
import { useUserConfigState } from '@/context/UserConfigContext';
import type { ExtendedTier } from '@/types/ExtendedTier';

type SurchargeType = 'shortTurn' | 'meal' | 'overnight' | 'holiday';

/**
 * Returns the first non-empty extended overtime tiers from a sibling surcharge config,
 * excluding the caller's own surcharge type.
 */
export function useDefaultExtendedTiers(exclude: SurchargeType): ExtendedTier[] | undefined {
  const state = useUserConfigState();

  return useMemo(() => {
    const sources: (ExtendedTier[] | undefined | null)[] = [
      exclude !== 'shortTurn' ? state.shortTurnConfig?.extendedOvertimeTiers : undefined,
      exclude !== 'meal'      ? state.mealConfig?.extendedOvertimeTiers      : undefined,
      exclude !== 'overnight' ? state.overnightConfig?.extendedOvertimeTiers  : undefined,
      exclude !== 'holiday'   ? state.holidayExtendedOvertimeTiers           : undefined,
    ];
    return sources.find((t): t is ExtendedTier[] => Array.isArray(t) && t.length > 0);
  }, [
    exclude,
    state.shortTurnConfig?.extendedOvertimeTiers,
    state.mealConfig?.extendedOvertimeTiers,
    state.overnightConfig?.extendedOvertimeTiers,
    state.holidayExtendedOvertimeTiers,
  ]);
}
